import { IsNumber, IsString } from 'class-validator';
import { ApiProperty, PartialType } from './decorators-nest';

export class PodcastDto {
  @IsString()
  @ApiProperty({
    description: 'Recipe id',
  })
  id: string;

  @ApiProperty({ description: 'Podcast title', required: true, example: 'À L’ÉCOUTE DE VOTRE FERTILITÉ' })
  @IsString()
  public title: string;

  @ApiProperty({
    description: 'Podcast description',
    required: true,
    example:
      'Pour vous aider dans votre parcours avec BeMum, le podcast “À l’écoute de votre fertilité” vous conseille et vous soutient tout au long de votre quotidien.',
  })
  @IsString()
  public description: string;

  @ApiProperty({
    description: 'Podcast season',
    required: true,
    example: 1,
  })
  @IsNumber()
  public season: number;

  @ApiProperty({
    description: 'Podcast episode',
    required: true,
    example: 1,
  })
  @IsNumber()
  public episode: number;

  @ApiProperty({
    description: 'Url of the image for the podcast',
    required: true,
    example: 'LIEN_HTTPS',
  })
  @IsString()
  public imageUrl: string;

  @ApiProperty({
    description: 'Url of the audio for the podcast',
    required: true,
    example: 'LIEN_HTTPS',
  })
  @IsString()
  public audioUrl: string;
}
export class CreatePodcastDto {
  @ApiProperty({ description: 'Podcast title', required: true, example: 'À L’ÉCOUTE DE VOTRE FERTILITÉ' })
  @IsString()
  public title: string;

  @ApiProperty({
    description: 'Podcast description',
    required: true,
    example:
      'Pour vous aider dans votre parcours avec BeMum, le podcast “À l’écoute de votre fertilité” vous conseille et vous soutient tout au long de votre quotidien.',
  })
  @IsString()
  public description: string;

  @ApiProperty({
    description: 'Podcast season',
    required: true,
    example: 1,
  })
  @IsNumber()
  public season: number;

  @ApiProperty({
    description: 'Podcast episode',
    required: true,
    example: 1,
  })
  @IsNumber()
  public episode: number;

  @ApiProperty({
    description: 'Url of the image for the podcast',
    required: true,
    example: 'LIEN_HTTPS',
  })
  @IsString()
  public imageUrl: string;

  @ApiProperty({
    description: 'Url of the audio for the podcast',
    required: true,
    example: 'LIEN_HTTPS',
  })
  @IsString()
  public audioUrl: string;
}

export class UpdatePodcastDto extends PartialType(CreatePodcastDto) {}
